module.exports = __webpack_public_path__ + "img/grey.5b0cdef6.webp";